import { setStepperValue } from './stepper.js';


/**
 * Initialises all party member steppers by matching party member labels to types.
 * Defaults to matching type by rendered position on the page. e.g. If "Guy" is rendered before "Buddy", "Guy" is assumed to be an "adults", "Buddy" is assumed to be "children"
 * @param {HTMLElement} stepperElements - an array of stepper elements (root object)
 * @param {object} presets - preset values for each party member
 */
export function initialisePartyMemberSteppers(
	stepperElements,
	presets = null,
    doDispatchChangeEvent = true
) {
    if (!presets) {
        console.log('No preset values passed. Setting all value to defaults.');
    }

    // const keys = Object.keys(presets || {});
    stepperElements.forEach((stepperEl, index) => {
        const labelEl = stepperEl.querySelector('label');
        if (!labelEl) return;

        const stepperId = stepperEl.dataset.partyId;
        
        if (!presets['_'+stepperId]) {
            console.log(`No preset key found for party member stepper at index ${index} (id: ${stepperId})`);
        }

        const presetValue = presets['_'+stepperId].qty ?? 0;

        // Fire change event on the last stepper to trigger a session -> state -> checkout-summary update and add at least 1 party member
        if (index == stepperElements.length - 1)
            setStepperValue(stepperEl, presetValue, doDispatchChangeEvent);
        else
            setStepperValue(stepperEl, presetValue);
    });
}



// TODO: this could be drastically simplified by passing the party member object from state and rendering based off of that
// I've settled on scrubbing JQuery from the function for now
export function buildPartyMemberDetailsContainers() {
    const partyMemberSteppers = Array.from(
        document.querySelectorAll('#atb-party-members-section .atb-party.atb-stepper')
    ).filter(el => el.offsetParent !== null); // equivalent to jquery :visible

    const partyDetailsSection = document.getElementById('atb-party-details-section');

    // Destroy any previous party member containers    
    const oldPmContainers = partyDetailsSection.querySelectorAll('.atb-party-member-details-container:not([data-is-js-template])');
    oldPmContainers
        .forEach(container => container.remove());


    if (partyMemberSteppers.length === 0) {
        const partySizeDropdown = document.getElementById('atb-party-size-row');
        const label             = partySizeDropdown.querySelector('label');
        const key               = label.textContent.trim().split(' ').join('-');

        const type       = depluralise(key);
        const idSelector = `atb-pmd-container-${type}`;

        const classes = 'atb-party-member-details-container separator pt-4 mb-4 d-none';

        const div           = document.createElement('div');
              div.id        = idSelector;
              div.className = classes;

        partyDetailsSection.appendChild(div);
    }

    partyMemberSteppers.forEach((stepper, index) => {
        let type = depluralise(
            stepper.querySelector('label span.atb-stepper-type').textContent.trim()
        );

        // check for special characters
        if (/[^a-zA-Z0-9\-]/.test(type)) {
            console.warn(
                `Party member type contains special characters, renaming to "party-member". Original type: ${type}`
            );
            type = 'party-member';
        }

        const idSelector = `atb-pmd-container-${type}`;

        let classes = 'atb-party-member-details-container separator pt-4 d-none';
        if (index === partyMemberSteppers.length - 1) {
            classes += ' mb-4';
        }

        const div           = document.createElement('div');
              div.id        = idSelector;
              div.className = classes;

        partyDetailsSection.appendChild(div);
    });
}


